import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import * as Yup from 'yup';
import {
  Col,
  FormatText,
  FormInput,
  FormSelect,
  FormSubmitButton,
  FormTextArea,
  MasterDetailForm,
  notification,
  OptionProps,
  Row,
} from '@digital/ui';
import { criarConsultiva } from '@app/api/sas/ordemCompra';
import { getAllAreasByDiretoriaOptions } from '@app/api/area';
import { getAllDepartamentoProAreaIdOptions, getAllDepartamentoProDiretoriaIdOptions } from '@app/api/departamento';
import { getAllDiretoriasOptions } from '@app/api/diretoria';
import { getAllDemandantes } from '@app/api/demanda';
import { SelectInfinity } from '@app/components';
import CurrencyInput from '@app/components/CurrencyInput';

const ModalCadastrarConsultiva = ({ exibirModal, setExibirModal }: any) => {
  const [departamentos, setDepartamentos] = useState<OptionProps[]>();
  const [areas, setAreas] = useState<OptionProps[]>();
  const [diretoriaId, setDiretoriaId] = useState<string | undefined>();
  const [areaId, setAreaId] = useState<string | undefined>();
  const [departamentoId, setDepartamentoId] = useState<string | undefined>();
  const [selectedDemandante, setSelectedDemandante] = useState<OptionProps>();
  const [listaDemandantes, setDemandantes] = useState<OptionProps[]>([]);

  useEffect(() => {
    setAreas([{ text: 'N/A', value: 'na' }]);
    setDepartamentos([{ text: 'N/A', value: 'na' }]);

    if (diretoriaId) {
      getAllAreasByDiretoriaOptions(diretoriaId).then(data => {
        let areas = [...data, { text: 'N/A', value: 'na' }];
        setAreas(areas);
      });
      getAllDepartamentoProDiretoriaIdOptions(diretoriaId).then(data => {
        let departamentos = [...data, { text: 'N/A', value: 'na' }];
        setDepartamentos(departamentos);
      });
    }
  }, [diretoriaId]);

  useEffect(() => {
    if (areaId && areaId !== 'na') {
      getAllDepartamentoProAreaIdOptions(areaId).then(data => {
        let departamentos = [...data, { text: 'N/A', value: 'na' }];
        setDepartamentos(departamentos);
      });
    }

    if (diretoriaId) {
      getAllDepartamentoProDiretoriaIdOptions(diretoriaId).then(data => {
        let departamentos = [...data, { text: 'N/A', value: 'na' }];
        setDepartamentos(departamentos);
      });
    }
  }, [areaId]);

  const handleChangeDiretoria = (value: string) => {
    setDiretoriaId(value);
    setAreaId(undefined);
    setDepartamentoId(undefined);
  };

  const handleChangeArea = (value: string) => {
    setAreaId(value);
    setDepartamentoId(undefined);
  };

  const onCancel = () => {
    setExibirModal(false);
  };

  const onSubmit = async (values: any) => {
  if (!selectedDemandante) {
    notification.warn('Selecione um demandante antes de continuar.');
    return;
  }

  const data = {
    ...values,
    demandanteId: selectedDemandante,
  };

  try {
    const result = await criarConsultiva(data);

    if (result) {
      notification.success('Consultiva criada com sucesso.');
      setExibirModal(false);
      window.location.reload();
    } else {
      notification.error(
        'Não foi possível criar a consultiva. Tente novamente.'
      );
    }
  } catch (error: any) {
    console.error('Erro ao criar consultiva:', error);

    if (error.response) {
      notification.error('Erro no servidor ao criar a consultiva.');
    } else if (error.request) {
      notification.error('Falha de conexão. Verifique sua internet e tente novamente.');
    } else {
      notification.error('Ocorreu um erro inesperado. Tente novamente.');
    }
  }
};

  useEffect(() => {
    getAllDemandantes().then(data => {
      if (data) {
        setDemandantes(data);
      }
    });
  }, []);

  const handleChangeDemandante = (value: any) => {
    setSelectedDemandante(value);
  };

  return (
    <>
      <Modal
        title="Criação de consultiva"
        visible={exibirModal}
        onCancel={() => onCancel()}
        footer={null}
        width="780px">
        {exibirModal && (
          <MasterDetailForm
            onSubmit={onSubmit}
            actions={[
              <FormSubmitButton noIcon type="primary">
                <FormatText id="Criar Consultiva" uppercase />
              </FormSubmitButton>,
            ]}>
            <Row>
              <FormSelect
                id="mrn-select-diretoria"
                label="Diretoria"
                name="diretoriaId"
                placeholder="Selecione uma opção"
                getOptions={getAllDiretoriasOptions}
                value={diretoriaId}
                onChange={value => handleChangeDiretoria(value)}
                span={4}
                required
                validateSchema={Yup.string().trim().required('Campo requerido.')}
              />
              <FormSelect
                id="mrn-select-area"
                label="Área"
                name="areaId"
                placeholder="Selecione uma opção"
                options={areas}
                span={4}
                value={areaId}
                onChange={value => handleChangeArea(value)}
                allowClear
                required
                validateSchema={Yup.string().trim().required('Campo requerido.')}
              />

              {departamentos && (
                <FormSelect
                  id="mrn-select-departamento"
                  label="Departamento"
                  name="departamentoId"
                  placeholder="Selecione uma opção"
                  options={departamentos}
                  value={departamentoId}
                  span={4}
                  onChange={value => setDepartamentoId(value)}
                  allowClear
                  required
                  validateSchema={Yup.string().trim().required('Campo requerido.')}
                />
              )}
            </Row>

            <Row>
              <Col span={4}>
                <SelectInfinity
                  label="Demandante"
                  name="demandanteId"
                  paginationOptions={listaDemandantes || []}
                  paginationSize={100}
                  value={selectedDemandante}
                  onChange={value => handleChangeDemandante(value)}
                  span={4}
                />
              </Col>
              <FormSelect
                name="tipo"
                label="Tipo"
                span={4}
                placeholder="Selecione uma opção"
                options={[
                  { value: 1, text: 'Nova Contratação' },
                  //{ value: 2, text: 'Aditivo' },
                  //{ value: 3, text: 'Acordo de Fornecimento' },
                  //{ value: 4, text: 'Faturamento Direto' },
                ]}
                required
              />
              <FormSelect
                name="ddi"
                label="DDI"
                span={4}
                placeholder="Selecione uma opção"
                options={[
                  { value: true, text: 'Sim' },
                  { value: false, text: 'Não' },
                ]}
                required
              />
            </Row>

            
            <Row>
              <FormSelect
                name="avaliacaoFinanceira"
                label="Avaliação Financeira"
                span={4}
                placeholder="Selecione uma opção"
                options={[
                  { value: true, text: 'Sim' },
                  { value: false, text: 'Não' },
                ]}
                required
              />

              <FormSelect
                name="ehVisitaTecnica"
                label="Visita Técnica"
                span={4}
                placeholder="Selecione uma opção"
                options={[
                  { value: true, text: 'Sim' },
                  { value: false, text: 'Não' },
                ]}
                required
              />

              <CurrencyInput label="Valor Inicial Consultiva" id='mrn-input-valor' name="valor" span={4} required/>
            </Row>
            <Row>
              <FormTextArea label="Objeto" name="objeto" id="objeto" span={12} required />
            </Row>
          </MasterDetailForm>
        )}
      </Modal>
    </>
  );
};

export default ModalCadastrarConsultiva;
